import React from 'react';
import { LucideIcon } from 'lucide-react';

interface NavigationCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  gradient: string;
  onClick: () => void;
}

export function NavigationCard({ title, description, icon: Icon, gradient, onClick }: NavigationCardProps) {
  return (
    <div 
      onClick={onClick}
      className={`bg-gradient-to-br ${gradient} p-0.5 rounded-xl transform transition-all hover:scale-105 cursor-pointer`}
    >
      <div className="bg-gray-900 p-6 rounded-lg h-full">
        <div className="flex items-center gap-4 mb-4">
          <Icon className="w-8 h-8" />
          <h2 className="text-2xl font-bold font-serif">{title}</h2>
        </div>
        <p className="text-gray-300">{description}</p>
      </div>
    </div>
  );
}